
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22.22","height":"15.59"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Groups","transform":"translate(-323.408 -451.532)"}},[_c('g',{attrs:{"id":"Group_25546","data-name":"Group 25546"}},[_c('g',{attrs:{"id":"Group_25544","data-name":"Group 25544","transform":"translate(323 494)"}},[_c('g',{attrs:{"id":"Group_25545","data-name":"Group 25545","fill":"none","stroke":"#5a677d","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"id":"Path_20287","data-name":"Path 20287","d":"M13.218 6.206a2.09 2.09 0 110 .008z","transform":"translate(2.064 -41.658)"}}),_c('path',{attrs:{"id":"Path_20286","data-name":"Path 20286","d":"M12.676 11.624a12.545 12.545 0 011.4-.316 7.1 7.1 0 011.206-.074c3.915 0 4.374 2.072 4.374 2.072","transform":"translate(2.079 -41.512)"}})])]),_c('g',{attrs:{"id":"Group_8261","data-name":"Group 8261","transform":"translate(324.321 452.432)"}},[_c('g',{attrs:{"id":"Group_8264","data-name":"Group 8264","fill":"none","stroke":"#5a677d","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('circle',{attrs:{"id":"Ellipse_176","data-name":"Ellipse 176","cx":"3.578","cy":"3.578","r":"3.578","transform":"rotate(-77.025 5.965 1.496)"}}),_c('path',{attrs:{"id":"Path_1306","data-name":"Path 1306","d":"M712.321-114.391s.89-3.476 7.458-3.476 7.337 3.476 7.337 3.476","transform":"translate(-712.321 128.169)"}})])])])])])
          )
        }
      }
    